import { Component, OnInit } from '@angular/core';
import { AppInitService } from '@core/services/app-init.service';

@Component({
  selector: 'app-kushki-initializer',
  template: '',
})
export class KushkiInitializerComponent implements OnInit {
  private static readonly kushkiScriptUrl = 'https://cdn.kushkipagos.com/kushki-checkout.js';

  constructor(private readonly appInitService: AppInitService) {}

  ngOnInit(): void {
    const settings = this.appInitService.Settings.ec;
    const shouldLoadKushkiScript =
      settings.isKushkiCardPaymentEnabled ||
      settings.isBankTransferEnabledForCheckout ||
      settings.isBankTransferEnabledForPartyOrderPayment;

    if (!shouldLoadKushkiScript) {
      return;
    }

    if (document.querySelector(`script[src="${KushkiInitializerComponent.kushkiScriptUrl}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.src = KushkiInitializerComponent.kushkiScriptUrl;
    script.async = true;
    script.defer = true;

    document.head.appendChild(script);
  }
}
